import './App.css';
import {Route, Routes} from 'react-router-dom';
import Main from './components/Main';

// filename app.js
import "bootstrap/dist/js/bootstrap.bundle.min";

import './scss/default.scss';
import React, {useEffect, useState} from "react";
import "jquery"
import About from "./components/About";
import RKV from "./components/rkv";
import Condition from "./components/Condition";
import Payment from "./components/payment";
import FAQ from "./components/faq";
import Privacy from "./components/privacy";
import Imprint from "./components/imprint";
import Contact from "./components/Contact";
import Career from "./components/Career";
import References from "./components/references";
import AllDestination from "./components/AllDestination";
import Type from "./components/Type";
import AllTypes from "./components/AllTypes";
import Finder from "./components/Finder";
import Trip from "./components/Trip";
import Destination from "./components/Destination";
import Calendar from "./components/calendar";
import NotFound from "./components/NotFound";
import NewsletterConfirm from "./components/NewsletterConfirm";
import NewsletterUnsubscribe from "./components/NewsletterUnsubscribe";
import {AxiosInterceptor} from "./components/utils/axiosConfig";
import Navigation from "./components/partial/nav/navigation";
import ScrollToTop, {fetchDestinations, fetchPartner, fetchTripTypes} from "./components/utils/utils";
import ProtectedRoute from "./context/ProtectedRoute";
import Login from "./components/account/Login";
import Dashboard from "./components/account/Dashboard";
import AuthProvider from "./context/AuthContext";
import Logout from "./components/account/Logout";
import NewsletterSubscribe from "./components/NewsletterSubscribe";
import OrderCatalog from "./components/OrderCatalog";
import Booking from "./components/booking/Booking";
import Footer2 from "./components/partial/Footer2";
import ReferencesForm from "./components/references-form";
import UnderConstruction from "./components/UnderConstruction";
import AccessibilityDeclaration from "./components/accessibility-declaration";
import DraftTrip from "./components/DraftTrip";


function App() {
    const [tripTypes, setTripTypes] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [partner, setPartner] = useState({});


    // todo: add the color values to db
    const root = document.documentElement;
    /*    if (partner.agency_no) {
            switch (Number(partner.agency_no)) {
                case  40523:
                    root?.style.setProperty("--main-color", "#00662B")
                    root?.style.setProperty("--secondary-color", "#A1C513")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#000")
                    break
                case  92006:
                    root?.style.setProperty("--main-color", "#0E6195")
                    root?.style.setProperty("--secondary-color", "#00B1DE")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#000")
                    break
                case  90435:
                    root?.style.setProperty("--main-color", "#943D0A")
                    root?.style.setProperty("--secondary-color", "#575756")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40066:
                    root?.style.setProperty("--main-color", "#007296")
                    root?.style.setProperty("--secondary-color", "#E30613")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  90339:
                    root?.style.setProperty("--main-color", "#C40613")
                    root?.style.setProperty("--secondary-color", "#E20613")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91252:
                    root?.style.setProperty("--main-color", "#110A35")
                    root?.style.setProperty("--secondary-color", "#110A35")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40499:
                    root?.style.setProperty("--main-color", "#E30512")
                    root?.style.setProperty("--secondary-color", "#E30512")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  20067:
                    root?.style.setProperty("--main-color", "#005F99")
                    root?.style.setProperty("--secondary-color", "#005F99")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91013:
                    root?.style.setProperty("--main-color", "#BA1516")
                    root?.style.setProperty("--secondary-color", "#BA1516")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40054:
                    root?.style.setProperty("--main-color", "#080E41")
                    root?.style.setProperty("--secondary-color", "#080E41")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40504:
                    root?.style.setProperty("--main-color", "#007B3D")
                    root?.style.setProperty("--secondary-color", "#007B3D")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91658:
                    root?.style.setProperty("--main-color", "#005F99")
                    root?.style.setProperty("--secondary-color", "#005F99")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91562:
                    root?.style.setProperty("--main-color", "#E4007B")
                    root?.style.setProperty("--secondary-color", "#E4007B")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40070:
                    root?.style.setProperty("--main-color", "#2570A6")
                    root?.style.setProperty("--secondary-color", "#2570A6")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  40500:
                    root?.style.setProperty("--main-color", "#00A443")
                    root?.style.setProperty("--secondary-color", "#00A443")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  60215:
                    root?.style.setProperty("--main-color", "#006AB2")
                    root?.style.setProperty("--secondary-color", "#006AB2")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91364:
                    root?.style.setProperty("--main-color", "#007BC4")
                    root?.style.setProperty("--secondary-color", "#007BC4")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91543:
                    root?.style.setProperty("--main-color", "#009A92")
                    root?.style.setProperty("--secondary-color", "#009A92")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  92001:
                    root?.style.setProperty("--main-color", "#CE0000")
                    root?.style.setProperty("--secondary-color", "#535353")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  91657:
                    root?.style.setProperty("--main-color", "#0860A5")
                    root?.style.setProperty("--secondary-color", "#0860A5")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                case  92031:
                    root?.style.setProperty("--main-color", "#6E552B")
                    root?.style.setProperty("--secondary-color", "#6E552B")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#FFFFFF")
                    break
                default:
                    root?.style.setProperty("--main-color", "#064D92")
                    root?.style.setProperty("--secondary-color", "#FFD500")
                    root?.style.setProperty("--main-text-color", "#FFFFFF")
                    root?.style.setProperty("--secondary-text-color", "#064D92")
                    break;
            }
        }*/

    useEffect(() => {
        fetchPartner().then((data) => {
            setPartner(data ?? {});
            root?.style.setProperty("--main-color", data.main_color ?? "#064D92")
            root?.style.setProperty("--secondary-color", data.secondary_color ?? "#FFD500")
            root?.style.setProperty("--main-text-color", data.main_text_color ?? "#FFFFFF")
            root?.style.setProperty("--secondary-text-color", data.secondary_text_color ?? "#FFFFFF")
            if (Number(data.agency_no) === Number(process.env.REACT_APP_GLOBALIS_AGENCY_NO)) {
                import((`./scss/globalis.scss`));
            }
        });

        fetchTripTypes().then((data) => {
            setTripTypes(data);
        });

        fetchDestinations().then((data) => {
            setDestinations(data ?? []);
        });

        document.title = `${partner?.name} - Hochwertige geführte Reisen zu fairen Preisen`;

    }, [partner.name]);

    return (<>
            <ScrollToTop></ScrollToTop>
            <AuthProvider>
                <AxiosInterceptor>
                    <Navigation partner={partner} tripTypes={tripTypes} destinations={destinations}/>
                    <Routes tripTypes={tripTypes}>
                        <Route path="/" element={<Main partner={partner} tripTypes={tripTypes}/>}/>
                        <Route path="/globalis" element={<About partner={partner}/>}/>
                        <Route path="/reisefinder"
                               element={<Finder partner={partner} tripTypes={tripTypes} destinations={destinations}/>}/>

                        <Route path="/reiseziele" element={<AllDestination partner={partner}/>}/>
                        <Route path="/reiseziele/:dest" element={<Destination partner={partner}/>}/>
                        <Route path="/reisearten" element={<AllTypes partner={partner} tripTypes={tripTypes}/>}/>
                        <Route path="/reisearten/:title" element={<Type partner={partner} tripTypes={tripTypes}/>}/>
                        <Route path="/reise/:title" element={<Trip partner={partner}/>}/>
                        <Route path="/reise-vorschau/:tId/" element={<DraftTrip partner={partner}/>}/>
                        <Route path="/reisekalender" element={<Calendar partner={partner} tripTypes={tripTypes}
                                                                        destinations={destinations}/>}/>
                        {/*<Route path="/reisebuchung/:title" element={<Checkout partner={partner}/>}/>*/}
                        <Route path="/reisebuchung/*" element={<Booking partner={partner}/>}/>

                        <Route path="informationen/rkv" element={<RKV partner={partner}/>}/>
                        <Route path="informationen/reisebedingungen" element={<Condition partner={partner}/>}/>
                        <Route path="informationen/zahlungsweisen" element={<Payment partner={partner}/>}/>
                        <Route path="informationen/faq" element={<FAQ partner={partner}/>}/>
                        <Route path="/datenschutz" element={<Privacy partner={partner}/>}/>
                        <Route path="/barrierefreiheitserklaerung" element={<AccessibilityDeclaration/>}/>
                        <Route path="/impressum" element={<Imprint partner={partner}/>}/>
                        <Route path="/kontakt" element={<Contact partner={partner}/>}/>
                        <Route path="/karriere" element={<Career partner={partner}/>}/>
                        <Route path="/referenzen" element={<References partner={partner}/>}/>
                        <Route path="/bewertungen" element={<ReferencesForm partner={partner}/>}/>
                        <Route path="/newsletter-anmeldung" element={<NewsletterSubscribe partner={partner}/>}/>
                        <Route path="/newsletter-bestaetigung" element={<NewsletterConfirm partner={partner}/>}/>
                        <Route path="/newsletter-abmeldung" element={<NewsletterUnsubscribe partner={partner}/>}/>
                        <Route path="/katalog-gratis-bestellen" element={<OrderCatalog partner={partner}/>}/>
                        <Route path="/prospekt-gratis-bestellen" element={<OrderCatalog partner={partner}/>}/>
                        <Route path='*' element={<NotFound/>}/>
                        <Route path='/notfound' element={<NotFound/>}/>
                        <Route path='/underconstruction' element={<UnderConstruction/>}/>
                        <Route path='/login' element={<Login partner={partner}/>}/>
                        <Route path='/logout' element={<Logout/>}/>
                        <Route element={<ProtectedRoute/>}>
                            <Route path="/dashboard" element={<Dashboard partner={partner}/>}/>
                        </Route>
                    </Routes>
                    <Footer2 partner={partner} tripTypes={tripTypes}/>
                </AxiosInterceptor>
            </AuthProvider>
        </>

    );
}

export default App;
